export default "__VITE_ASSET__CMX$c1FT__"